import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Api_Endpoints } from '../../Api/apiEndpoint';
import { makeApiCall } from '../../Api/makeApiCall';
import {
  DashboardIcon,
  ClaimList,
  VendorList,
  Invoices,
  Report,
  Logout,
  Logo,
  Menu
} from '../../Constant/ImageConstant';
import { getUserSession } from '../../utils/auth';
import './SideBar.css';

const iconMap = {
  DashboardIcon,
  ClaimList,
  VendorList,
  Invoices,
  Report,
  Logout,
  Logo,
  Menu
};

const Sidebar = ({ isOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const user_data = getUserSession(); // Get user session to determine roles
  console.log(user_data?.user, 'User Data');

  const [menuItems, setMenuItems] = useState([]);
  
  // Define sidebar items
  const sidebarList = [
    {
      childId: 1,
      childUrl: '/',
      childMenuName: 'Dashboard',
      childMenuIcon: 'DashboardIcon',
      childMenuIsActive: true,
      childMenuAccess: ['Admin',"Account", 'Maker','Checker','Checker1', 'Finance', "Manager",'Management', 'Ceo', 'Coo', 'Chairman', 'Director_1', 'Director_2', 'Director_3', 'Director_4', 'Director_5', 'Independent_director', 'HR Manager', 'Operation-1', 'Operation-2', 'Operation-3', 'IT Manager'] // Accessible by Admin and Maker
    },
    {
      childId: 2,
      childUrl: '/View-Vendor',
      childMenuName: 'Add Vendor',
      childMenuIcon: 'ClaimList',
      childMenuIsActive: true,
      childMenuAccess: ['Maker'] // Accessible by Maker only
    },
    {
      childId: 3,
      childUrl: '/Vendors',
      childMenuName: 'Vendors List',
      childMenuIcon: 'VendorList',
      childMenuIsActive: true,
      childMenuAccess: ['Account','Admin', 'Maker','Checker', 'Checker1', 'Finance', "Manager",'Management', 'Ceo', 'Coo', 'Chairman', 'Director_1', 'Director_2', 'Director_3', 'Director_4', 'Director_5', 'Independent_director', 'HR Manager', 'Operation-1', 'Operation-2', 'Operation-3', 'IT Manager' ] // Accessible by multiple roles
    },  
    {
      childId: 4,
      childUrl: '/InvoiceList',
      childMenuName: 'Invoice List',
      childMenuIcon: 'VendorList',
      childMenuIsActive: true,
      childMenuAccess: [ "Account","Manager", "Manager",'Management', 'Finance', 'Ceo', 'Coo', 'Chairman', 'Director_1', 'Director_2', 'Director_3', 'Director_4', 'Director_5', 'Independent_director', 'HR Manager', 'Operation-1', 'Operation-2', 'Operation-3', 'IT Manager',] // Accessible by multiple roles
    },
    {
      childId: 5,
      childUrl: '/downloadInvoice',
      childMenuName: 'Download Invoice',
      childMenuIcon: 'VendorList',
      childMenuIsActive: true,
      childMenuAccess: [ "Account",] // Accessible by multiple roles
    },
    {
      childId: 6,
      childUrl: '/draftVendorList',
      childMenuName: 'Draft Vendor',
      childMenuIcon: 'VendorList',
      childMenuIsActive: true,
      childMenuAccess: [ "Maker",] // Accessible by multiple roles
    },
  ];

  // Fetch menu items based on user roles
  const fetchMenuItems = () => {
    const filteredMenu = sidebarList.filter(item => {
      if (Array.isArray(item.childMenuAccess)) {
        // Check if the user's role is in the allowed roles array
        return item.childMenuAccess.includes(user_data?.user);
      }
      return true; // Default: include all menu items without restrictions
    });
    setMenuItems(filteredMenu);
  };

  useEffect(() => {
    fetchMenuItems();
  }, []);

  const handleLogout = () => {
     navigate('/');

    localStorage.clear();
    // window.location.replace('/');
    window.location.reload('');

  };
  const isActive = (path) => {
    return location.pathname === path;
  };


  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <ul className="sidebar-menu">
        {menuItems?.map((item, index) => (
          <li
            key={index}
            className={`menu-item ${isActive(item.childUrl) ? 'active' : ''}`}
            onClick={() => navigate(item.childUrl)}
          >
            <img
              src={iconMap[item.childMenuIcon]}
              alt={item.childMenuName}
              className="menu-icon"
              // className={`menu-icon ${isActive(item.childMenuIcon) ? 'active' : ''}`}
            />
            {item.childMenuName}
          </li>
        ))}
      </ul>

      {/* <div
        onClick={handleLogout}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          cursor: 'pointer',
          position: 'absolute',
          bottom: 0,
          left: '50px'
        }}
      >
        <p style={{ color: '#dc4226' }}>Logout</p>
        <img
          src={Logout}
          alt="Menu"
          style={{ height: '40px', width: '40px' }}
        />
      </div> */}
    </div>
  );
};

export default Sidebar;
